import { events } from "@constants/tracking";
import { ENDPOINT_FEEDBACK } from "@constants/urls";
import { trackCustomEvent } from "analytics";

export type AppLaunchParams = {
	userName: string;
	email: string;
	appName: string;
	feedback: string;
	type: "Notify app launch";
	examName?: string;
	appLanguage: string;
	companyName: string;
	projectId: number;
	organizationId: number;
	appVersion: string;
	platform: string;
	bundleId: string;
};

export const handleNotifyUserOnAppLaunch = async (params: AppLaunchParams) => {
	try {
		const {
			userName,
			email,
			appName,
			feedback,
			type = "Notify app launch",
			examName,
			appLanguage,
			companyName,
			projectId,
			organizationId,
			appVersion,
			bundleId,
			platform,
		} = params;

		const body = JSON.stringify({
			userName,
			email,
			appVersion,
			feedback,
			appName,
			projectId: projectId.toString(),
			organizationId: organizationId.toString(),
			companyName,
			platform,
			appContext: examName,
			bundleId,
			source: type,
			appLanguage,
		});

		const response = await fetch(ENDPOINT_FEEDBACK, {
			method: "POST",
			body,
		});

		trackCustomEvent({
			eventName: events.waitlistJoined,
			...params,
		});

		return { success: response.ok };
	} catch (_error) {
		return { success: false };
	}
};
